import { SurveyElement } from '../survey-bundle/survey-bundle.interface';

export type ArgType =
  | 'text'
  | 'number'
  | 'date'
  | 'datetime'
  | 'time'
  | 'text_range'
  | 'number_range'
  | 'date_range'
  | 'single_select'
  | 'multi_select'
  | 'rank_select'
  | 'row_select'
  | 'row_multi_select'
  | 'row_number'
  | 'none'
  | 'matrix_row';

export interface Operator {
  slug: string;
  label: string;
  argType: ArgType;
}

export const OPERATORS: Record<string, Operator> = {
  // Choice Logic
  is: { slug: 'is', label: 'Is', argType: 'single_select' },
  is_not: { slug: 'is_not', label: 'Is Not', argType: 'single_select' },
  inc_any: { slug: 'inc_any', label: 'Includes Any', argType: 'multi_select' },
  not_inc_any: { slug: 'not_inc_any', label: 'Not Includes Any', argType: 'multi_select' },

  inc_all: { slug: 'inc_all', label: 'Includes All', argType: 'multi_select' },
  is_ex: { slug: 'is_ex', label: 'Is Exactly', argType: 'multi_select' },
  is_any_of: { slug: 'is_any_of', label: 'Is Any Of', argType: 'multi_select' },
  is_not_any_of: { slug: 'is_not_any_of', label: 'Is Not Any Of', argType: 'multi_select' },
  is_not_ex: { slug: 'is_not_ex', label: 'Is Not Exactly', argType: 'multi_select' },

  count_eq: { slug: 'count_eq', label: 'Count Equals', argType: 'number' },
  count_gt: { slug: 'count_gt', label: 'Count Is Greater Than', argType: 'number' },
  count_gte: { slug: 'count_gte', label: 'Count Is Greater Than or Equal To', argType: 'number' },
  count_lt: { slug: 'count_lt', label: 'Count Is Less Than', argType: 'number' },
  count_lte: { slug: 'count_lte', label: 'Count Is Less Than or Equal To', argType: 'number' },
  // Text Logic
  eq_text: { slug: 'eq_text', label: 'Equals', argType: 'text' },
  neq_text: { slug: 'neq_text', label: 'Does Not Equal', argType: 'text' },
  cont: { slug: 'cont', label: 'Contains', argType: 'text' },
  not_cont: { slug: 'not_cont', label: 'Does Not Contain', argType: 'text' },
  sw: { slug: 'sw', label: 'Starts With', argType: 'text' },
  ew: { slug: 'ew', label: 'Ends With', argType: 'text' },

  // Numeric Logic
  eq_num: { slug: 'eq_num', label: 'Equals', argType: 'number' },
  neq_num: { slug: 'neq_num', label: 'Not Equals', argType: 'number' },
  gt: { slug: 'gt', label: 'Greater Than', argType: 'number' },
  gte: { slug: 'gte', label: 'Greater Than or Equal To', argType: 'number'},
  lt: { slug: 'lt', label: 'Less Than', argType: 'number' },
  lte: { slug: 'lte', label: 'Less Than or Equal To', argType: 'number'},
  bet_num: { slug: 'bet_num', label: 'Between', argType: 'number_range' },
  not_bet_num: {slug: 'not_bet_num',label: 'Not Between',argType: 'number_range',},

  // Date/Time Logic
  on_date: { slug: 'on_date', label: 'On', argType: 'date' },
  bef_date: { slug: 'bef_date', label: 'Before', argType: 'date' },
  aft_date: { slug: 'aft_date', label: 'After', argType: 'date' },
  bet_date: { slug: 'bet_date', label: 'Between', argType: 'date_range' },

  // State Logic
  ans: { slug: 'ans', label: 'Is Answered', argType: 'none' },
  nans: { slug: 'nans', label: 'Is Not Answered', argType: 'none' },
  liked: { slug: 'liked', label: 'Liked', argType: 'none' },
  disliked: { slug: 'disliked', label: 'Disliked', argType: 'none' },

  // Matrix / Ordering
  rank_is: {
  slug: 'rank_is',
  label: 'Is Ranked',
  argType: 'rank_select',
},
rank_not_is: {
  slug: 'rank_not_is',
  label: 'Is Not Ranked',
  argType: 'rank_select',
},
rank_gt: {
  slug: 'rank_gt',
  label: 'Rank Is Greater Than',
  argType: 'rank_select',
},
rank_gte: {
  slug: 'rank_gte',
  label: 'Rank Is Greater Than or Equal',
  argType: 'rank_select',
},
rank_lt: {
  slug: 'rank_lt',
  label: 'Rank Is Less Than',
  argType: 'rank_select',
},
rank_lte: {
  slug: 'rank_lte',
  label: 'Rank Is Less Than or Equal',
  argType: 'rank_select',
},
rank_bet: {
  slug: 'rank_bet',
  label: 'Rank Is Between',
  argType: 'number_range',
},
rank_not_bet: {
  slug: 'rank_not_bet',
  label: 'Rank Is Not Between',
  argType: 'number_range',
},
// ================================
// Grid Logic
// ================================

// Single Grid
row_is: {
  slug: 'row_is',
  label: 'Row Is',
  argType: 'row_select'
},

row_is_not: {
  slug: 'row_is_not',
  label: 'Row Is Not',
  argType: 'row_select'
},


// Multiple Grid
row_inc_any: {
  slug: 'row_inc_any',
  label: 'Row Includes Any',
  argType: 'row_multi_select'
},

row_not_inc_any: {
  slug: 'row_not_inc_any',
  label: 'Row Does Not Include Any',
  argType: 'row_multi_select'
},

row_inc_all: {
  slug: 'row_inc_all',
  label: 'Row Includes All',
  argType: 'row_multi_select'
},

row_is_ex: {
  slug: 'row_is_ex',
  label: 'Row Is Exactly',
  argType: 'row_multi_select'
},

row_is_not_ex: {
  slug: 'row_is_not_ex',
  label: 'Row Is Not Exactly',
  argType: 'row_multi_select'
},

row_is_any_of: {
  slug: 'row_is_any_of',
  label: 'Row Is Any Of',
  argType: 'row_multi_select'
},

row_is_not_any_of: {
  slug: 'row_is_not_any_of',
  label: 'Row Is Not Any Of',
  argType: 'row_multi_select'
},


// Row Count
row_count_eq: {
  slug: 'row_count_eq',
  label: 'Row Count Equals',
  argType: 'row_number'
},

row_count_gt: {
  slug: 'row_count_gt',
  label: 'Row Count Is Greater Than',
  argType: 'row_number'
},

row_count_gte: {
  slug: 'row_count_gte',
  label: 'Row Count Is Greater Than or Equal',
  argType: 'row_number'
},

row_count_lt: {
  slug: 'row_count_lt',
  label: 'Row Count Is Less Than',
  argType: 'row_number'
},

row_count_lte: {
  slug: 'row_count_lte',
  label: 'Row Count Is Less Than or Equal',
  argType: 'row_number'
},

  // sum_is: { slug: 'sum_is', label: 'Sum is', argType: 'number' },
  // row_is: { slug: 'row_is', label: 'Row logic', argType: 'matrix_row' },
};

export interface Condition {
  id?: string;
  condition_set_id?: string;
  condition_element_id: number;
  operator: string;
  option_id?: string;
  row_key?: number;
  value_manual?: any;
  option_targets?: string[];
  rank: number;
}

export enum ConditionSetElementType {
  QUESTION_ELEMENT = 'questionElement',
  LOGIC_ELEMENT = 'logicElement',
  ENDING = 'ending',
}
export interface ConditionSet {
  id: string;
  skip_logic_id?: string;
  logical_operator: 'AND' | 'OR';
  description: string;
  conditions: Condition[];
  condition_set_element_id?: number;
  condition_set_element_type: ConditionSetElementType;
}

export interface ComposedCondition extends Condition {
  /** * Pre-resolved on server.
   * Essential because the client can't fetch options from the bundle.
   */
  option_key: number;

  /** * NEW: The type of the question (e.g., 'numeric', 'single-choice').
   * The client uses this to determine which OPERATOR_FUNCTIONS to run.
   */
  element: SurveyElement;

  option_keys: number[];
}

export interface ComposedConditionSet extends Omit<ConditionSet, 'conditions'> {
  conditions: ComposedCondition[];
  // Map of ElementID -> Value
  dependencies: Record<number, any>;
}
